/**
 * En-tête de page paramètres : titre + zone d'action (ex. bouton Créer).
 * Sticky en haut du conteneur scroll.
 */
const SettingsPageHeader = ({ title, action }) => (
  <div className="-mx-[20px] flex items-center justify-between bg-white px-[20px] py-4 pl-[calc(20px+16px)]">
    <h1 className="ft-xl font-semibold text-gray-900">{title}</h1>
    {action ?? null}
  </div>
);

export default SettingsPageHeader;
